module.exports = __webpack_public_path__ + "img/web3_2.6c89985f.jpg";